export enum FoundationEvent {
    NAVIGATION_MENU_MOUSE_ENTER = 'foundation:navigationMenu:mouseEnter',
}
